// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
}
.input__input {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  height: 60px;
  width: 100%;
  border: 1px solid #e9e9e9;
  background: #ffffff;
  border-radius: 8px;
  padding-left: 10px;
  padding-top: 5px;
}
.input__input-disabled {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid #e8e9e9;
  height: 60px;
  width: 100%;
  background-color: #f3f5f6;
  border-radius: 8px;
  padding-left: 10px;
  color: #999999;
}
.input__right-align {
  direction: RTL;
  padding-right: 10px;
}

.text-label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.text-input-error {
  position: absolute;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: rgb(253, 110, 110);
}

.icon {
  position: relative;
}
.icon__icon {
  position: absolute;
  right: 16px;
  top: 16px;
}

::placeholder {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #c1c1c1;
}`, "",{"version":3,"sources":["webpack://./src/common/text-input/text-input.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,WAAA;AAAJ;AAEI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADR;AAII;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAHR;AAMI;EACI,cAAA;EACA,mBAAA;AAJR;;AAQA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALJ;;AAQA;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;AAOI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AALR;;AASA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANJ","sourcesContent":[".input {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n\n    width: 100%;\n\n    &__input {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n\n        height: 60px;\n        width: 100%;\n        border: 1px solid #e9e9e9;\n        background: #ffffff;\n        border-radius: 8px;\n        padding-left: 10px;\n        padding-top: 5px;\n    }\n\n    &__input-disabled {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n\n        border: 1px solid #e8e9e9;\n        height: 60px;\n        width: 100%;\n        background-color: #f3f5f6;\n        border-radius: 8px;\n        padding-left: 10px;\n        color: #999999;\n    }\n\n    &__right-align {\n        direction: RTL; \n        padding-right: 10px;\n    }\n}\n\n.text-label {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    color: #505054;\n}\n\n.text-input-error {\n    position: absolute;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: rgb(253, 110, 110);\n}\n\n.icon {\n    position: relative;\n\n    &__icon {\n        position: absolute;\n        right: 16px;\n        top: 16px;\n    }\n}\n\n::placeholder {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #c1c1c1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
